import { initGraphQLTada } from 'gql.tada';

import type { introspection } from '#types/graphql-env';

export const graphql = initGraphQLTada<{
  introspection: introspection;
  scalars: {
    DateTime: string;
    LocalDate: string;
    Image: string;
    Text: string;
    JSON: string;
    Instant: string;
    Long: number;
    ObjectScalar: unknown;
    PostDataJson: object;
    StringObjectMapScalar: string;
    UNREPRESENTABLE: string;
    UUID: string;
  };
}>();

export type { FragmentOf, ResultOf, VariablesOf } from 'gql.tada';
export { readFragment } from 'gql.tada';
